import type { AxiosError, AxiosRequestConfig } from 'axios'
import type { Schedule } from '../api/types'
import { useSuspenseQuery } from '@tanstack/react-query'
import { getSchedule } from '../api/schedule'
import { TAG_TYPES } from '../config'

interface UseScheduleOptions {
  axiosConfig?: AxiosRequestConfig
}

export function useSchedule(options: UseScheduleOptions = {}) {
  const { axiosConfig } = options

  return useSuspenseQuery<Schedule, AxiosError>({
    queryKey: [TAG_TYPES.SCHEDULE],
    queryFn: async () => {
      return await getSchedule(axiosConfig)
    },
  })
}

export default useSchedule
